import React from 'react';
import { motion } from 'framer-motion';

const IndustryRecognitionSection = () => {
    const fadeUpVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
    };

    const slideLeftVariant = {
        hidden: { opacity: 0, y: 20, x: 0 },
        visible: { opacity: 1, y: 0, x: 0, transition: { duration: 0.8, ease: "easeOut" } }
    };

    return (
        <section className="w-full bg-[#F1F1F1] overflow-hidden">
            <div className="max-w-[1440px] mx-auto flex flex-col-reverse md:flex-row">

                <div className="w-full md:w-1/2 px-[20px] md:px-[40px] lg:px-[80px] py-[40px] sm:py-[60px] lg:py-[120px] flex flex-col justify-center">
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={fadeUpVariant}
                    >
                        <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] tracking-tight leading-[1.2] lg:leading-[1.1] mb-[16px] md:mb-[24px]">
                            Industry Analyst<br className="hidden md:block" /> Recognition
                        </h2>
                        <p className="font-graphik text-[#6C7689] text-[14px] md:text-[16px] font-[500] leading-[1.6] max-w-[500px] mb-[24px] md:mb-[50px]">
                            We are honored to be recognized for our accomplishments as a global leader across the industry analyst community.
                        </p>

                        <a
                            href="#"
                            className="inline-flex items-center text-[14px] md:text-[16px] font-[600] text-[#01386A] hover:text-[#ED6800] transition-colors duration-300 group"
                        >
                            <span className="border-b-[2px] border-[#01386A] group-hover:border-[#ED6800] pb-[2px] transition-colors duration-300">
                                Learn More
                            </span>
                            <span className="ml-2 text-[#ED6800] text-[16px] font-[600] transition-transform duration-300 group-hover:translate-x-1">&gt;</span>
                        </a>
                    </motion.div>
                </div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    variants={slideLeftVariant}
                    className="w-full md:w-1/2 h-[240px] sm:h-[300px] md:h-auto shrink-0"
                >
                    <img
                        src="/assets/awards/img4.png"
                        alt="Industry Analyst Recognition"
                        className="w-full h-full object-cover"
                    />
                </motion.div>

            </div>
        </section>
    );
};

export default IndustryRecognitionSection;